import {
  Component,
  EventEmitter,
  inject,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {Avatar} from 'primeng/avatar';
import {PlayerProfile} from '../../model/player-profile';
import {PlayerSessionService} from '../../service/player-session.service';
import {Subscription} from 'rxjs';
import {RestErrorHelper} from '../../../../helper/rest-error-helper';
import {TranslateService} from '@ngx-translate/core';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-player-profile-avatar',
  standalone: true,
  imports: [
    Avatar
  ],
  templateUrl: './player-profile-avatar.component.html',
  styleUrl: './player-profile-avatar.component.scss'
})
export class PlayerProfileAvatarComponent implements OnChanges, OnInit, OnDestroy
{
  private playerSessionService = inject(PlayerSessionService);
  private restErrorHelper = inject(RestErrorHelper);
  private translate = inject(TranslateService);

  @Input() size: 'normal' | 'large' | 'xlarge' = 'normal';
  @Input() shape: 'square' | 'circle' = 'square';
  @Input() clickable: boolean;
  @Input() loginIcon: boolean;

  @Output() onClick = new EventEmitter<any>();

  imageUrl: string;
  initials: string;

  playerProfile: PlayerProfile;
  playerProfileChangeSubscription: Subscription;

  ngOnInit(): void
  {
    this.playerProfileChanged(this.playerSessionService.playerProfileObject);
    this.playerProfileChangeSubscription = this.playerSessionService.onPlayerProfileChanged.subscribe(
      value => this.playerProfileChanged(value));
    console.log('[PlayerProfileAvatarComponent] playerProfile: ', this.playerProfile);
  }

  ngOnDestroy(): void
  {
    this.playerProfileChangeSubscription?.unsubscribe();
  }

  public ngOnChanges(changes: SimpleChanges): void
  {
    /*console.log('ngOnChanges', changes);
    if (changes.playerProfile)
      this.initInitials();*/
  }

  private playerProfileChanged(value: PlayerProfile): void
  {
    this.playerProfile = value;
    this.initInitials();
  }

  private initInitials(): void
  {
    if (this.playerProfile?.pictureUrl)
    {
      this.imageUrl = this.playerProfile?.pictureUrl;
    }
    else
    {
      this.imageUrl = undefined;

      if (this.playerProfile?.firstname?.length > 0 && this.playerProfile?.lastname?.length > 0)
        this.initials = this.playerProfile?.firstname[0].toUpperCase() + this.playerProfile?.lastname[0].toUpperCase();
      else if (this.playerProfile?.lastname?.length > 0)
        this.initials = this.playerProfile?.lastname[0].toUpperCase();
      else if (this.playerProfile?.firstname?.length > 0)
        this.initials = this.playerProfile?.firstname[0].toUpperCase();
      else
      {
        this.initials = undefined;
      }
    }

    // console.log('initials: ' + this.initials);
  }

  public onImageError(event: any): void
  {
    console.log('onImageError, url: ' + this.playerProfile?.pictureUrl, event);
    this.imageUrl = undefined;
  }

  public onClickInavtive(event: any): void
  {
    this.restErrorHelper.showInfoMessageService(
      this.translate.instant('PLAYER_PROFILE_IMAGE_BLOCKED_TEXT', {value: (this.playerProfile.pictureInactiveText || '-')}),
      environment.toastDurationLong);

    this.onClick.emit(event);
  }
}
